import {Component} from '@angular/core';
import {BaseError} from "./base-error";

@Component({
  templateUrl: './server-error-page.component.html',
  styleUrls: ['./base-error.scss']
})
export class ServerErrorPageComponent extends BaseError {
}
